import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { defaultTheme } from "@/utils/functions";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        ...defaultTheme,
      },
    },
  },
  icons: {
    values: {
    },
  },
});
